import { render, staticRenderFns } from "./messageNotify.vue?vue&type=template&id=ee84a28c&scoped=true&"
import script from "./messageNotify.vue?vue&type=script&lang=js&"
export * from "./messageNotify.vue?vue&type=script&lang=js&"
import style0 from "./messageNotify.vue?vue&type=style&index=0&id=ee84a28c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee84a28c",
  null
  
)

export default component.exports